import { Dropdown } from "antd";
import React, { ButtonHTMLAttributes, useEffect, useState } from "react";
import {
  BiCaretDown,
  BiCaretLeft,
  BiCaretRight,
  BiChevronsLeft,
  BiChevronsRight,
} from "react-icons/bi";
import { Content, DropMenu } from "./styles";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  totalItems: number;
  currentPage: number;
  prev: () => void;
  next: () => void;
  first: () => void;
  last: () => void;
  limitChange: (value:number) => void;
}
export function Pagination({
  totalItems,
  currentPage,
  prev,
  next,
  first,
  last,
  limitChange,
  ...rest
}: Props) {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  function handlePerPageChange(value: number) {
    setItemsPerPage(value);
  }
  function handlePerPageClick() {
    return (
      <DropMenu>
        <li
          onClick={() => {
            handlePerPageChange(10);
          }}
        >
          10
        </li>
        <li
          onClick={() => {
            handlePerPageChange(15);
          }}
        >
          15
        </li>
        <li
          onClick={() => {
            handlePerPageChange(20);
          }}
        >
          20
        </li>
      </DropMenu>
    );
  }
  useEffect(() => {
   limitChange(itemsPerPage);
  }, [itemsPerPage]);
  return (
    <Content>
      <div className="data-show">
        Exibindo{" "}
        <Dropdown
          overlay={handlePerPageClick}
          trigger={["click"]}
          placement="top"
        >
          <span>
            {itemsPerPage}
            <BiCaretDown />
          </span>
        </Dropdown>
        de <span>{totalItems}</span> registros.
      </div>
      <div className="pagination">
        {currentPage + 1 <= 0 ? 1: currentPage + 1} / {totalPages === 0 ? 1:totalPages}
        <div onClick={first}>
          <BiChevronsLeft />
        </div>
        <div onClick={prev}>
          <BiCaretLeft />
        </div>
        <div onClick={next}>
          <BiCaretRight />
        </div>
        <div onClick={last}>
          <BiChevronsRight />
        </div>
      </div>
    </Content>
  );
}
